import React, { useState } from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { gtmTracking } from "@/utils/gtm-tracking"
/**
 * FeatureDemoTabsFooter Component
 *
 * Displays feature highlights with tab functionality - image/content at top,
 * tabs with titles and descriptions at bottom
 *
 */

const FeatureDemoTabsFooter = ({
  kicker,
  title,
  description,
  highlights = [],
  className = "",
}) => {
  const [activeTab, setActiveTab] = useState(0)

  if (!highlights.length) return null

  const activeHighlight = highlights[activeTab]

  return (
    <section className={`container-fluid mb-0 feature-tabs-end ${className}`}>
      <div className="feature-tabs-end__container">
        {(title || description) && (
          <div className="feature-tabs-end__header">
            {kicker && <span className="heading-kicker">{kicker}</span>}
            {title && <h2 className="feature-tabs-end__title">{title}</h2>}
            {description && (
              <div className="feature-tabs-end__description p--lg">
                {description}
              </div>
            )}
          </div>
        )}

        {/* Desktop: Content area - shows active tab content */}
        <div className="feature-tabs-end__content feature-tabs-end__content--desktop">
          {activeHighlight.image && (
            <div className="feature-tabs-end__image">
              <GatsbyImage
                image={getImage(activeHighlight.image)}
                alt={activeHighlight.imageAlt || activeHighlight.title || ""}
              />
            </div>
          )}
        </div>

        {/* Desktop: Tabs at bottom with titles and descriptions */}
        <div className="feature-tabs-end__tabs feature-tabs-end__tabs--desktop">
          {highlights.map((highlight, index) => (
            <button
              key={index}
              type="button"
              className="feature-tabs-end__tab"
              data-active={activeTab === index ? "true" : "false"}
              onClick={() => {
                gtmTracking(
                  "Tab Click",
                  highlight.title,
                  "Feature Demo Tabs Footer",
                )()
                setActiveTab(index)
              }}
            >
              <h5 className="feature-tabs-end__tab-title">{highlight.title}</h5>
              <div className="feature-tabs-end__tab-description">
                {highlight.description}
              </div>
            </button>
          ))}
        </div>

        {/* Mobile: Each section with title, description, and image */}
        <div className="feature-tabs-end__mobile-container">
          {highlights.map((highlight, index) => (
            <div key={index} className="feature-tabs-end__mobile-item">
              <div className="feature-tabs-end__mobile-content">
                <h5 className="feature-tabs-end__mobile-title">
                  {highlight.title}
                </h5>
                <div className="feature-tabs-end__mobile-description">
                  {highlight.description}
                </div>
              </div>
              {highlight.image && (
                <div className="feature-tabs-end__image feature-tabs-end__image--mobile">
                  <GatsbyImage
                    image={getImage(highlight.image)}
                    alt={highlight.imageAlt || highlight.title || ""}
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FeatureDemoTabsFooter
